export const ALGODAO_BCI = 1;
export const DEMAIS_ATRIBUTOS_SUSTENTAVEIS = 2;
export const MISTO = 3;
export const COMPANIES = {
    RENNER: {
        ID: '001',
        NAME: 'Renner',
    },
    CAMICADO: {
        ID: '003',
        NAME: 'Camicado',
    },
    YOUCOM: {
        ID: '004',
        NAME: 'Youcom',
    }
}
export const TAGTYPES = {
    ZEBRA: {
        ID: 1,
        NAME: 'ZPL',
    },
    TXT: {
        ID: 2,
        NAME: 'TXT',
    }
}
export const SIM = 'Sim'
export const NAO = 'Não'
export const NATUREZAPEDIDO = {
    NORMAL: 'Normal',
    IMPORTADO: 'Importado'
}
export const SCHEDULING_REPORT_HEADERS = [
	'carga',
	'cd',
	'departamento',
	'dtEntrega',
	'fornecedor',
	'horaEntrega',
	'horaEntregaFim',
	'nomePortao',
	'pedido',
	'qtdPecas',
	'qtdPedidos',
	'qtdVolumes',
	'semanaComercial',
	'status',
	'tipoEmpacotamento',
	'tipoProduto'
]

export const PRE_SCHEDULING_REPORT_HEADERS = [
	'fornecedor',
	'descricao',
	'ativo',
	'capacidade',
	'empresa',
	'cd',
	'agendaFixa',
	'dataInicial',
	'horaInicial',
	'horaFinal',
	'dataFinal'
]

export const ORDER_REPORT_HEADERS = [
		'id',
		'calendarioComercial_dataFinal',
		'calendarioComercial_dataInicial',
		'calendarioComercial_semanaComercial',
		'carga_id',
		'carga_status',
		'cnpjComprador',
		'departamento',
		'departamentoId',
		'detalhe_cfaComposicao',
		'detalhe_cfaDescricao',
		'detalhe_cfaGrupoId',
		'detalhe_char1',
		'detalhe_classe',
		'detalhe_classeId',
		'detalhe_comentarios',
		'detalhe_composicao',
		'detalhe_departamento',
		'detalhe_descricaoCurta',
		'detalhe_descricaoItem',
		'detalhe_dtAprovacao',
		'detalhe_dtRevisao',
		'detalhe_ean',
		'detalhe_fornecedorId',
		'detalhe_grupoMaterial',
		'detalhe_grupoMaterialId',
		'detalhe_grupoPadrao',
		'detalhe_imagemDescricao',
		'detalhe_imagemEndereco',
		'detalhe_imagemNome',
		'detalhe_ind4',
		'detalhe_medida',
		'detalhe_medidaId',
		'detalhe_ncm',
		'detalhe_pais',
		'detalhe_paisFornecedorId',
		'detalhe_paisOrigemId',
		'detalhe_paisPrimarioInd',
		'detalhe_remarkDesc',
		'detalhe_sequencial1',
		'detalhe_sequencial2',
		'detalhe_statusMedida',
		'detalhe_subClasse',
		'detalhe_subClasseId',
		'detalhe_tamExemploId',
		'detalhe_tamPadraoId',
		'detalhe_vpn',
		'dtCancelamento',
		'dtEmissao',
		'dtEntregaFim',
		'dtEntregaInicio',
		'dtRecebimentoPo',
		'empresa_id',
		'empresa_nome',
		'fastInd',
		'ffdd',
		'formaPg',
		'formaPgId',
		'fornecedor_cidade',
		'fornecedor_cnpj',
		'fornecedor_ediPoInd',
		'fornecedor_email',
		'fornecedor_id',
		'fornecedor_nome',
		'fornecedor_uf',
		'item_aliquotaIcms',
		'item_aliquotaIpi',
		'item_cnpj',
		'item_codItem',
		'item_custoUnitario',
		'item_formaEnvio',
		'item_itemPai',
		'item_localizacaoFisica',
		'item_localizacaoFisicaTipo',
		'item_nivelItem',
		'item_nivelTransacional',
		'item_orderNo',
		'item_packInd',
		'item_packNo',
		'item_pacote',
		'item_pacotePackInd',
		'item_pais',
		'item_paisNome',
		'item_precoCusto',
		'item_qtCancelada',
		'item_qtCompra',
		'item_qtItens',
		'item_qtRecebida',
		'item_qtVolume',
		'item_reducaoBaseIcms',
		'item_roundLvl',
		'item_skuCompra',
		'item_tamPacoteInner',
		'item_tamPacoteSupp',
		'item_unidadeVarejo',
		'item_valorBaseIcms',
		'localizacaoFisica_id',
		'localizacaoFisica_nome',
		'naturezaPedido',
		'naturezaPedidoId',
		'observacao',
		'origemPedido',
		'pais',
		'pgCond',
		'pgCondId',
		'pgDiasPrazo',
		'qtCompra',
		'qtVolumes',
		'status',
		'sustentabilidade',
		'termosFrete',
		'tipoPedido',
		'tipoPedidoDescricao',
		'utilCode',
		'utilizaSubContratado',
		'versao',
        'amostraPedido'
]